import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-withdraw-report-normal',
    templateUrl: './withdraw-report-normal.component.html',
    styleUrls: ['./withdraw-report-normal.component.scss']
})
export class WithdrawReportNormalComponent implements OnInit {
    @Input('withdrawreports') withdrawreports;
    @Input('title') title;
    constructor() { }

    ngOnInit() {
    }
    public convertUTCDateToLocalDate(date): Date {
        let newdate = new Date(date);
        var newDate = new Date(newdate.getTime() - newdate.getTimezoneOffset() * 60 * 1000);
        return newDate;
      }


}
